import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  title: string;
  body: string;
  category?: string;
};

type MutationResponse = {
  status: number;
  data: { reply_id: string };
};

export const useCreateQuickReplyMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while creating the quick reply',
    endpoint: '/api/admin/whatsapp/quick-replies',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
